import { combineReducers } from 'redux'
import IMember from 'types/IMember'
import { SET_MEMBERAction } from '../actions'

const defMember:IMember = {
  name: ''
}

const setMember = (state=defMember, action: SET_MEMBERAction): IMember => {
  return action.data || defMember
}


export default combineReducers({
	member: setMember
})


